export const COUNTRIES = [
    { "name": "Afghanistan", "code": "+93", "iso": "AF", "flag": "🇦🇫" },
    { "name": "Albania", "code": "+355", "iso": "AL", "flag": "🇦🇱" },
    { "name": "Algeria", "code": "+213", "iso": "DZ", "flag": "🇩🇿" },
    { "name": "Andorra", "code": "+376", "iso": "AD", "flag": "🇦🇩" },
    { "name": "Angola", "code": "+244", "iso": "AO", "flag": "🇦🇴" },
    { "name": "Argentina", "code": "+54", "iso": "AR", "flag": "🇦🇷" },
    { "name": "Armenia", "code": "+374", "iso": "AM", "flag": "🇦🇲" },
    { "name": "Australia", "code": "+61", "iso": "AU", "flag": "🇦🇺" },
    { "name": "Austria", "code": "+43", "iso": "AT", "flag": "🇦🇹" },
    { "name": "Azerbaijan", "code": "+994", "iso": "AZ", "flag": "🇦🇿" },
    { "name": "Bahamas", "code": "+1-242", "iso": "BS", "flag": "🇧🇸" },
    { "name": "Bahrain", "code": "+973", "iso": "BH", "flag": "🇧🇭" },
    { "name": "Bangladesh", "code": "+880", "iso": "BD", "flag": "🇧🇩" },
    { "name": "Belgium", "code": "+32", "iso": "BE", "flag": "🇧🇪" },
    { "name": "Benin", "code": "+229", "iso": "BJ", "flag": "🇧🇯" },
    { "name": "Bhutan", "code": "+975", "iso": "BT", "flag": "🇧🇹" },
    { "name": "Bolivia", "code": "+591", "iso": "BO", "flag": "🇧🇴" },
    { "name": "Bosnia and Herzegovina", "code": "+387", "iso": "BA", "flag": "🇧🇦" },
    { "name": "Botswana", "code": "+267", "iso": "BW", "flag": "🇧🇼" },
    { "name": "Brazil", "code": "+55", "iso": "BR", "flag": "🇧🇷" },
    { "name": "Brunei Darussalam", "code": "+673", "iso": "BN", "flag": "🇧🇳" },
    { "name": "Bulgaria", "code": "+359", "iso": "BG", "flag": "🇧🇬" },
    { "name": "Cambodia", "code": "+855", "iso": "KH", "flag": "🇰🇭" },
    { "name": "Cameroon", "code": "+237", "iso": "CM", "flag": "🇨🇲" },
    { "name": "Canada", "code": "+1", "iso": "CA", "flag": "🇨🇦" },
    { "name": "Chile", "code": "+56", "iso": "CL", "flag": "🇨🇱" },
    { "name": "China", "code": "+86", "iso": "CN", "flag": "🇨🇳" },
    { "name": "Colombia", "code": "+57", "iso": "CO", "flag": "🇨🇴" },
    { "name": "Costa Rica", "code": "+506", "iso": "CR", "flag": "🇨🇷" },
    { "name": "Croatia", "code": "+385", "iso": "HR", "flag": "🇭🇷" },
    { "name": "Cuba", "code": "+53", "iso": "CU", "flag": "🇨🇺" },
    { "name": "Cyprus", "code": "+357", "iso": "CY", "flag": "🇨🇾" },
    { "name": "Czechia", "code": "+420", "iso": "CZ", "flag": "🇨🇿" },
    { "name": "Denmark", "code": "+45", "iso": "DK", "flag": "🇩🇰" },
    { "name": "Dominican Republic", "code": "+1-809", "iso": "DO", "flag": "🇩🇴" },
    { "name": "Ecuador", "code": "+593", "iso": "EC", "flag": "🇪🇨" },
    { "name": "Egypt", "code": "+20", "iso": "EG", "flag": "🇪🇬" },
    { "name": "El Salvador", "code": "+503", "iso": "SV", "flag": "🇸🇻" },
    { "name": "Estonia", "code": "+372", "iso": "EE", "flag": "🇪🇪" },
    { "name": "Ethiopia", "code": "+251", "iso": "ET", "flag": "🇪🇹" },
    { "name": "Finland", "code": "+358", "iso": "FI", "flag": "🇫🇮" },
    { "name": "France", "code": "+33", "iso": "FR", "flag": "🇫🇷" },
    { "name": "Germany", "code": "+49", "iso": "DE", "flag": "🇩🇪" },
    { "name": "Greece", "code": "+30", "iso": "GR", "flag": "🇬🇷" },
    { "name": "Hong Kong", "code": "+852", "iso": "HK", "flag": "🇭🇰" },
    { "name": "Hungary", "code": "+36", "iso": "HU", "flag": "🇭🇺" },
    { "name": "India", "code": "+91", "iso": "IN", "flag": "🇮🇳" },
    { "name": "Indonesia", "code": "+62", "iso": "ID", "flag": "🇮🇩" },
    { "name": "Iran", "code": "+98", "iso": "IR", "flag": "🇮🇷" },
    { "name": "Iraq", "code": "+964", "iso": "IQ", "flag": "🇮🇶" },
    { "name": "Ireland", "code": "+353", "iso": "IE", "flag": "🇮🇪" },
    { "name": "Israel", "code": "+972", "iso": "IL", "flag": "🇮🇱" },
    { "name": "Italy", "code": "+39", "iso": "IT", "flag": "🇮🇹" },
    { "name": "Japan", "code": "+81", "iso": "JP", "flag": "🇯🇵" },
    { "name": "Jordan", "code": "+962", "iso": "JO", "flag": "🇯🇴" },
    { "name": "Kenya", "code": "+254", "iso": "KE", "flag": "🇰🇪" },
    { "name": "Kuwait", "code": "+965", "iso": "KW", "flag": "🇰🇼" },
    { "name": "Lebanon", "code": "+961", "iso": "LB", "flag": "🇱🇧" },
    { "name": "Libya", "code": "+218", "iso": "LY", "flag": "🇱🇾" },
    { "name": "Luxembourg", "code": "+352", "iso": "LU", "flag": "🇱🇺" },
    { "name": "Malaysia", "code": "+60", "iso": "MY", "flag": "🇲🇾" },
    { "name": "Maldives", "code": "+960", "iso": "MV", "flag": "🇲🇻" },
    { "name": "Mexico", "code": "+52", "iso": "MX", "flag": "🇲🇽" },
    { "name": "Morocco", "code": "+212", "iso": "MA", "flag": "🇲🇦" },
    { "name": "Nepal", "code": "+977", "iso": "NP", "flag": "🇳🇵" },
    { "name": "Netherlands", "code": "+31", "iso": "NL", "flag": "🇳🇱" },
    { "name": "New Zealand", "code": "+64", "iso": "NZ", "flag": "🇳🇿" },
    { "name": "Nigeria", "code": "+234", "iso": "NG", "flag": "🇳🇬" },
    { "name": "Norway", "code": "+47", "iso": "NO", "flag": "🇳🇴" },
    { "name": "Oman", "code": "+968", "iso": "OM", "flag": "🇴🇲" },
    { "name": "Pakistan", "code": "+92", "iso": "PK", "flag": "🇵🇰" },
    { "name": "Philippines", "code": "+63", "iso": "PH", "flag": "🇵🇭" },
    { "name": "Poland", "code": "+48", "iso": "PL", "flag": "🇵🇱" },
    { "name": "Portugal", "code": "+351", "iso": "PT", "flag": "🇵🇹" },
    { "name": "Qatar", "code": "+974", "iso": "QA", "flag": "🇶🇦" },
    { "name": "Romania", "code": "+40", "iso": "RO", "flag": "🇷🇴" },
    { "name": "Russia", "code": "+7", "iso": "RU", "flag": "🇷🇺" },
    { "name": "Saudi Arabia", "code": "+966", "iso": "SA", "flag": "🇸🇦" },
    { "name": "Singapore", "code": "+65", "iso": "SG", "flag": "🇸🇬" },
    { "name": "South Africa", "code": "+27", "iso": "ZA", "flag": "🇿🇦" },
    { "name": "South Korea", "code": "+82", "iso": "KR", "flag": "🇰🇷" },
    { "name": "Spain", "code": "+34", "iso": "ES", "flag": "🇪🇸" },
    { "name": "Sri Lanka", "code": "+94", "iso": "LK", "flag": "🇱🇰" },
    { "name": "Sweden", "code": "+46", "iso": "SE", "flag": "🇸🇪" },
    { "name": "Switzerland", "code": "+41", "iso": "CH", "flag": "🇨🇭" },
    { "name": "Thailand", "code": "+66", "iso": "TH", "flag": "🇹🇭" },
    { "name": "Turkey", "code": "+90", "iso": "TR", "flag": "🇹🇷" },
    { "name": "Ukraine", "code": "+380", "iso": "UA", "flag": "🇺🇦" },
    { "name": "United Arab Emirates", "code": "+971", "iso": "AE", "flag": "🇦🇪" },
    { "name": "United Kingdom", "code": "+44", "iso": "GB", "flag": "🇬🇧" },
    { "name": "United States", "code": "+1", "iso": "US", "flag": "🇺🇸" },
    { "name": "Vietnam", "code": "+84", "iso": "VN", "flag": "🇻🇳" },
    { "name": "Yemen", "code": "+967", "iso": "YE", "flag": "🇾🇪" },
    { "name": "Zimbabwe", "code": "+263", "iso": "ZW", "flag": "🇿🇼" }
  ];
  